<template>
    <div class="agent-page">
        <div style="display: flex; flex-direction: column; text-align: start;">
            <h2 class="page-title" style="font-size: 15px;">企业采购--公开招标项目流程--招标项目编号：E1101050893002128　招标项目名称：中山大厦项目</h2>
            <div style="display: flex; align-items: center; justify-content: space-between;">
                <h2 class="page-title" style="margin-top: 10px;">一键归档</h2>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>

        <!-- 主要内容区域 -->
        <div class="main-content">
            <div class="table-container">
                <el-table :data="tableData" style="width: 100%" :show-header="true" border class="archive-table">
                    <el-table-column prop="no" label="NO." align="left" header-align="left" width="80">
                    </el-table-column>
                    <el-table-column prop="sectionName" label="标段名称" align="center" header-align="center"
                        min-width="150">
                    </el-table-column>
                    <el-table-column prop="sectionNumber" label="标段编号" align="center" header-align="center"
                        min-width="180">
                    </el-table-column>
                    <el-table-column prop="fileStatus" label="文件生成状态" align="center" header-align="center"
                        min-width="120">
                    </el-table-column>
                    <el-table-column prop="createTime" label="标段创建时间" align="center" header-align="center"
                        min-width="160">
                    </el-table-column>
                    <el-table-column prop="operation" label="操作" align="center" header-align="center" width="200">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleGenerate(scope.row)"
                                style="margin-right: 10px;">
                                生成
                            </el-button>
                            <el-button type="text" size="small" @click="handleDownload(scope.row)">
                                下载
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页区域 -->
            <div class="pagination-section">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="total" class="pagination" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OneClickArchive',
    data() {
        return {
            tableData: [
            ],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            jumpPage: 1
        }
    },
    methods: {
        // 返回项目流程界面
        handleBack() {
            this.$router.go(-1)
        },

        // 生成按钮点击
        handleGenerate(row) {
            this.$message.info(`生成 ${row.sectionName}`)
        },

        // 下载按钮点击
        handleDownload(row) {
            this.$message.info(`下载 ${row.sectionName}`)
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.loadData()
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val
            this.loadData()
        },

        // 跳转页面
        handleJumpPage() {
            if (this.jumpPage && this.jumpPage > 0) {
                this.currentPage = this.jumpPage
                this.loadData()
            }
        },

        // 加载数据
        loadData() {
        }
    }
}
</script>

<style lang="less" scoped>
.agent-page {
    .main-content {
        margin-top: 20px;
        overflow: hidden;

        .table-container {
            .archive-table {
                .el-table__header {
                    th {
                        background-color: #f8fafc;
                        color: #64748b;
                        font-weight: 500;
                        border-color: #e2e8f0;
                    }
                }

                .el-table__body {
                    td {
                        color: #1f2937;
                        border-color: #e2e8f0;
                    }
                }
            }

            .pagination-section {
                display: flex;
                justify-content: flex-end;
                border-radius: 8px;
            }
        }
    }
}
</style>
